export const BASE_URL = process.env.REACT_APP_API_URL || 'https://veloclik-front-inte-ws.velogik.com/api/1.0/';
export const API_KEY = process.env.REACT_APP_API_KEY || 'Ea74sLgKLKeA2Wv748Zrzs37';
export const TIMEOUT = 100000000;
export const PWD_SEED = process.env.REACT_APP_PWD_SEED || '2n&5K#A7zk#5M';
export const CONFIG_ENDPOINT = 'root/config';
export const LOCALE_ENDPOINT = 'root/translations';
